function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var ModTemplate = require('./../../lib/templates/modtemplate');
var Disburse = /*#__PURE__*/function (_ModTemplate) {
  function Disburse(app) {
    var _this;
    _classCallCheck(this, Disburse);
    _this = _callSuper(this, Disburse, [app]);
    _this.app = app;
    _this.slug = 'disburse';
    _this.name = 'disburse';
    _this.description = '';
    _this.categories = 'Core Utilities Messaging';
    _this["class"] = 'utility';
    _this.status = 'prod';
    _this.styles = ['/disburse/style.css', '/saito/saito.css'];
    return _possibleConstructorReturn(_this, _this);
  }
  _inherits(Disburse, _ModTemplate);
  return _createClass(Disburse, [{
    key: "initialize",
    value: function initialize(app) {
      _superPropGet(Disburse, "initialize", this, 3)([app]);
      if (this.browser_active) {
        this.styles = ['/disburse/style.css', '/saito/saito.css'];
      }
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var this_mod, this_wallet_balance, click_button, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (this.browser_active) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this_mod = this;
              document.querySelector('.wallet-value').innerHTML = this.app.wallet.publicKey;
              _t = parseFloat;
              _context.n = 2;
              return this.app.wallet.getBalance();
            case 2:
              this_wallet_balance = _t(_context.v);
              document.querySelector('.balance-value').innerHTML = this.app.browser.formatNumberToLocale(this_wallet_balance);
              //
              //	Manual input
              //
              click_button = document.querySelector('#validate-input');
              click_button.onclick = function (e) {
                var raw_data = document.querySelector('#disburse-input').value;
                this_mod.parseData(raw_data, this_wallet_balance);
              };
            //
            //	Paste Logic
            //

            // let input_area = document.querySelector("#disburse-input");
            // input_area.addEventListener("paste", (e) => {
            // 	e.preventDefault();
            // 	let paste = e.clipboardData.getData("raw_data");
            // 	input_area.value = paste;
            // 	this_mod.parseData(paste);
            // });
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
    /*
    async onConfirmation(blk, tx, conf) {
    	if (this.app.BROWSER && !tx.isTo(this.publicKey)) {
    	return;
    }
    	let txmsg = tx.returnMessage();
    try {
    	if (conf == 0) {
    		}
    } catch (err) {
    	console.log('ERROR in ' + this.name + ' onConfirmation: ' + err);
    }
    }
    */
  }, {
    key: "parseData",
    value: function parseData(raw_data, this_wallet_balance) {
      var _this2 = this;
      /*    expected data, list of 'wallet \t value \n'    */
      try {
        // console.log('Splitting data in rows');
        // Split on new line - and discard empty lines?
        var rows = raw_data.split(/\n/).filter(Boolean);
        var dataArray = [];
        if (rows.length > 0) {
          // console.log('Numbers of wallets:' + rows.length);
          var total_out = 0;
          for (var i = 0; i < rows.length; i++) {
            var row = rows[i];
            row = row.split(/\s+/);
            if (row.length == 2) {
              // console.log(row);
              total_out = total_out + parseFloat(row[1]);
              dataArray.push(row);
            } else {
              console.log('ERROR at row[' + i + ']\n data is:' + rows[i]);
              // alert('Unable to parse, please verify.');
            }
          }
          if (dataArray.length == rows.length && this_wallet_balance >= total_out) {
            var message_area = document.querySelector('.disburse-message');
            message_area.style.display = 'block';
            document.getElementById('total_wallet').innerHTML = dataArray.length;
            document.getElementById('total_out').innerHTML = this.app.browser.formatNumberToLocale(total_out);
            document.getElementById('sender_balance').innerHTML = this.app.browser.formatNumberToLocale(this_wallet_balance);
            document.getElementById('final_balance').innerHTML = this.app.browser.formatNumberToLocale(this_wallet_balance - total_out);
            document.getElementById('validate-input').remove();
            document.getElementById('disburse-input').readOnly = true;
            var button_area = document.querySelector('.disburse-button-area');
            var reset_button = document.createElement('button');
            reset_button.id = 'reset';
            reset_button.innerHTML = 'Reset';
            button_area.appendChild(reset_button);
            reset_button.addEventListener('click', function (e) {
              dataArray = [];
              document.location.reload();
            });
            var sendTransaction_button = document.createElement('button');
            sendTransaction_button.id = 'send-transaction';
            sendTransaction_button.innerHTML = 'Send transaction';
            button_area.appendChild(sendTransaction_button);
            sendTransaction_button.addEventListener('click', function (e) {
              _this2.sendBalance(dataArray);
            });
          } else {
            if (this_wallet_balance < total_out) alert('Not enought funds');else {
              alert('Unable to parse, please check wallet funds or recievers.');
            }
          }
        } else {
          alert('Unable to parse, please verify.');
        }
      } catch (error) {
        console.log(error);
      }
    }
  }, {
    key: "sendBalance",
    value: function () {
      var _sendBalance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dataArray) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              try {
                console.log('sendBalance()');
                document.getElementById('send-transaction').remove();
                // console.table(dataArray);
                this.sendBalanceTransaction(dataArray);
              } catch (error) {
                console.log(error);
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function sendBalance(_x) {
        return _sendBalance.apply(this, arguments);
      }
      return sendBalance;
    }()
  }, {
    key: "sendBalanceTransaction",
    value: function () {
      var _sendBalanceTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dataArray) {
        var _this3 = this;
        var senders, receivers, amounts, timestamp, unique_hash, ticker, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              senders = [];
              receivers = [];
              amounts = [];
              dataArray.forEach(function (row) {
                senders.push(_this3.app.wallet.publicKey);
                receivers.push(row[0]);
                amounts.push(row[1]);
              });
              timestamp = new Date().getTime();
              unique_hash = btoa(senders + receivers + amounts + timestamp);
              ticker = 'SAITO';
              console.log('senders.length :' + senders.length);
              // if (senders.length > 1) {
              console.log('sendPayments');
              _context4.n = 1;
              return this.app.wallet.sendPayments(senders, receivers, amounts, timestamp, unique_hash, /*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(res) {
                  return _regenerator().w(function (_context3) {
                    while (1) switch (_context3.n) {
                      case 0:
                        console.log('hash:\t' + res.hash);
                        if (res.hash) {
                          salert('Success, please wait - transaction hash: ' + res.hash.substring(0, 250));
                        }
                        if (res.err) {
                          salert('Error: ' + res.err);
                        }
                      case 1:
                        return _context3.a(2);
                    }
                  }, _callee3);
                }));
                return function (_x3) {
                  return _ref.apply(this, arguments);
                };
              }(), ticker);
            case 1:
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t2 = _context4.v;
              console.log(_t2);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function sendBalanceTransaction(_x2) {
        return _sendBalanceTransaction.apply(this, arguments);
      }
      return sendBalanceTransaction;
    }()
  }]);
}(ModTemplate);
module.exports = Disburse;